var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rotate-hint",class:_vm.type},[_c('icon',{attrs:{"name":_vm.type === 'ebn' ? 'phone-rotate-ebn' : 'phone-rotate'}}),_c('div',[_vm._v(_vm._s(_vm.$t("rotate_screen")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }